var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#EB2019"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2253_8586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.886 34.6724C42.8494 34.814 42.7843 34.9467 42.6947 35.0623C42.6051 35.1779 42.4929 35.2739 42.3649 35.3445C42.2386 35.4188 42.0985 35.4667 41.9532 35.4853C41.808 35.5038 41.6605 35.4927 41.5197 35.4525C41.3782 35.4142 41.2456 35.3483 41.1296 35.2585C41.0137 35.1686 40.9166 35.0567 40.844 34.9291L38.3065 30.4635C38.1633 30.2042 38.1279 29.8987 38.2079 29.6131C38.2864 29.3354 38.4714 29.1 38.7225 28.9585C38.8493 28.8864 38.9892 28.8402 39.1339 28.8227C39.2786 28.8052 39.4253 28.8166 39.5655 28.8563L39.6639 28.893C39.907 28.9852 40.1103 29.1593 40.239 29.3854L42.7766 33.8511C42.917 34.1004 42.9562 34.3945 42.886 34.6724Z",
    stroke: "white",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3535 32.4916L59.2787 53.7526C59.3562 53.8904 59.4595 54.0105 59.5824 54.1066C59.7053 54.2028 59.8456 54.274 59.9956 54.315C60.1457 54.356 60.3035 54.3666 60.4592 54.3462C60.6149 54.3258 60.7664 54.2743 60.9045 54.1945C61.0427 54.1146 61.1651 54.0074 61.2639 53.8793C61.3624 53.7513 61.4355 53.605 61.4786 53.4487C61.5217 53.2922 61.5339 53.1289 61.5146 52.9691C61.4954 52.8095 61.4454 52.6563 61.368 52.5183L61.3674 52.517L49.462 31.2728L47.3535 32.4916Z",
    stroke: "white",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8968 23.2937C54.0082 22.9172 53.0543 22.7065 52.0841 22.6778C50.74 22.6381 49.4121 22.9478 48.2314 23.5741C47.3107 24.1294 46.5176 24.8696 45.9037 25.7471C45.3639 26.5187 44.9729 27.3822 44.7478 28.2937L44.6613 28.6878C44.6203 28.9022 44.5328 29.1052 44.4052 29.2823C44.2776 29.4593 44.1127 29.6055 43.9229 29.7121L43.9226 29.713L43.0605 30.1971L43.6143 31.1604L44.3976 30.7199L49.0384 28.107C48.9293 27.7752 48.8618 27.4302 48.8422 27.0791C48.8058 26.4245 48.9312 25.7717 49.2073 25.1775L49.2251 25.1383L49.247 25.1017C49.5202 24.6379 49.8881 24.2368 50.327 23.9245C50.762 23.6148 51.2571 23.3999 51.7805 23.291L51.7796 23.2907C52.7502 23.0753 53.7593 23.1534 54.6795 23.5076L54.8968 23.2937Z",
    stroke: "white",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0576 36.0174L32.9394 36.0469L32.921 28.1184L34.0429 28.0889L34.0576 28.1184L34.0576 36.0174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8418 27.7715L25.8398 27.7715L25.8398 62.4687L28.8418 62.4687L28.8418 27.7715Z",
    stroke: "white",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0576 32.6406L34.0576 31.5038L29.511 31.5038L29.511 32.6406L34.0576 32.6406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_8586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRapper);
export default __webpack_public_path__ + "static/media/icon-rapper.baed75bee8ffe6cbc03eb107e6348fdc.svg";
export { ForwardRef as ReactComponent };